/**
 * @generated SignedSource<<dee11bff89d0794a4563b801a08cbc47>>
 * @relayHash 27525e0111911cf215931b0215a4665f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f1b7235682c5f2907ce503a95e333c2caaa1a2442090046507e02c8dcfb09963

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedParentQuery } from './decomposedParentQuery.graphql';

const node: PreloadableConcreteRequest<decomposedParentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f1b7235682c5f2907ce503a95e333c2caaa1a2442090046507e02c8dcfb09963",
    "metadata": {},
    "name": "decomposedParentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
